// extracted by mini-css-extract-plugin
module.exports = {"Button":"ControlsWrapper_Button__2oyih"};